import {useMemo} from 'react';

import {useCategoriesAtomValue} from '@web-catalog/store/categories';

export const useCategoryToCategoryName = () => {
  const {appsCategories, gamesCategories} = useCategoriesAtomValue();

  return useMemo<Record<string, string>>(
    () =>
      [...gamesCategories, ...appsCategories].reduce(
        (a, x) => {
          a[x.category] = x.categoryName;
          a[x.category.toLowerCase()] = x.categoryName;

          return a;
        },
        {} as Record<string, string>,
      ),
    [gamesCategories, appsCategories],
  );
};
